<template>
  <div class="detail-page">
    <!-- 顶部导航栏 -->
    <div class="nav-bar">
      <span class="nav-back" @click="$router.back()">
        <i class="el-icon-arrow-left"></i>
      </span>
      <span class="nav-title">订单详情</span>
    </div>

    <!-- 内容区 -->
    <div class="content">
      <!-- 路线信息卡片 -->
      <div class="route-card">
        <div class="route-header">
          <span class="route-title">{{ order.start_city_name }} - {{ order.end_city_name }}</span>
          <span class="status-tag" :class="statusTagClass">{{ order.daijia_server_status_text }}</span>
        </div>
        <div class="route-divider"></div>
        <div class="info-row">
          <span class="info-label">车源编号</span>
          <span class="info-value">{{ order.id }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">来源</span>
          <span class="info-value">
            {{ order.channelText }}
          </span>
        </div>
        <div class="info-row highlight">
          <span class="info-label">全程</span>
          <span class="info-value bold">{{ order.total_km }}km</span>
        </div>
        <div class="info-row">
          <span class="info-label">下单时间</span>
          <span class="info-value">{{ order.add_time ? order.add_time : '--' }}</span>
        </div>
        <!-- 已接单状态：显示接单时间 -->
        <div v-if="order.daijia_server_status == 1" class="info-row">
          <span class="info-label">接单时间</span>
          <span class="info-value">{{ order.rob_time ? order.rob_time : '--' }}</span>
        </div>
      </div>

      <!-- 提车/交车联系人信息 -->
      <div class="location-card">
        <div class="location-item">
          <div class="location-icon icon-blue">提</div>
          <div class="location-info">
            <div class="contact-header">
              <span class="contact-name">{{ order.start_linkman }}</span>
              <span class="contact-phone">{{ order.start_mobile }}</span>
            </div>
            <p class="location-text">{{ order.start_province_name + order.start_city_name + order.start_address }}</p>
          </div>
        </div>
        <div class="location-divider"></div>
        <div class="location-item">
          <div class="location-icon icon-orange">交</div>
          <div class="location-info">
            <div class="contact-header">
              <span class="contact-name">{{ order.end_linkman }}</span>
              <span class="contact-phone">{{ order.end_mobile }}</span>
            </div>
            <p class="location-text">{{ order.end_province_name + order.end_city_name + order.end_address }}</p>
          </div>
        </div>
      </div>

      <!-- 时间与车辆信息 -->
      <div class="vehicle-card">
        <div class="info-row">
          <span class="info-label">提车时间</span>
          <span class="info-value bold">{{ order.estimate_start_time ? order.estimate_start_time : '--' }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">交车时间</span>
          <span class="info-value">{{ order.estimate_end_time ? order.estimate_end_time : '--' }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">品牌车型</span>
          <span class="info-value">{{ order.car_type }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">车牌号</span>
          <span class="info-value">{{ order.car_platenumber }}</span>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="action-bar">
      <!-- 未接单已派单 -->
      <template v-if="order.daijia_server_status == 0 && order.member_id == userInfo.member_id">
        <button class="btn btn-primary" @click="handleAgree">确认接单</button>
      </template>
      <!-- 未接单未抢单 -->
      <template v-if="order.daijia_server_status == 0 && order.member_id == 0">
        <button class="btn btn-primary" @click="handleGrab">确认抢单</button>
      </template>
      <!-- 已接单 -->
      <template v-else-if="order.daijia_server_status == 1">
        <button class="btn btn-primary" @click="handleStartService">开始服务</button>
      </template>
      <!-- 进行中 -->
      <template v-else-if="order.daijia_server_status == 2">
        <button class="btn btn-primary" @click="handleDeliver">交付车辆</button>
      </template>
    </div>

    <!-- 抢单成功弹窗 -->
    <div v-if="showSuccess" class="modal-mask" @click="showSuccess = false">
      <div class="success-modal" @click.stop>
        <span class="modal-close" @click="showSuccess = false">
          <i class="el-icon-close"></i>
        </span>
        <div class="success-icon">
          <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="32" fill="#52c41a"/>
            <path d="M18 33 L28 43 L46 23" stroke="#fff" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <p class="success-text">接单成功，请及时提车运输！</p>
        <div class="success-order">
          <span>{{ order.start_city_name }}</span>
          <i class="el-icon-right"></i>
          <span>{{ order.end_city_name }}</span>
        </div>
        <button class="success-btn" @click="goMyOrders">立即查看</button>
      </div>
    </div>

    <!-- 合同签约提示弹窗 -->
    <div v-if="showSignModal" class="sign-mask" @click="showSignModal = false">
      <div class="sign-modal" @click.stop>
        <p class="sign-text">您的合同尚未签约，请先签约合同！</p>
        <div class="sign-btns">
          <button class="sign-btn cancel-btn" @click="showSignModal = false">取消</button>
          <button class="sign-btn confirm-btn" @click="handleSignNow">立即签约</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderInfo, agreePush, robOrder, startServer, doneServer, getSignUp } from '@/api/order'
import { getLng, getLat } from '@/utils/auth'
import { getUserInfo } from '@/utils/auth'
export default {
  name: 'OrderDetail',
  data() {
    return {
      userInfo: getUserInfo(),
      orderId: this.$route.query.id || '',
      orderStatus: '',
      loading: false,
      showSuccess: false,
      showSignModal: false,
      order: {}
    }
  },
  computed: {
    statusTagClass() {
      const status = this.order.daijia_server_status
      const map = { 0: 'tag-blue', 1: 'tag-teal', 2: 'tag-orange', 3: 'tag-gray' }
      return map[status] || 'tag-blue'
    }
  },
  created() {
    if (this.orderId) {
      this.loadOrder()
    }
  },
  methods: {
    async loadOrder() {
      this.loading = true
      try {
        const res = await getOrderInfo(this.orderId)
        if (res.code === 0 && res.data) {
          this.order = res.data
          this.orderStatus = this.mapStatus(res.data.status)
        }
      } catch (err) {
        this.$message.error(err.message || '获取订单详情失败')
      } finally {
        this.loading = false
      }
    },
    mapStatus(status) {
      const map = { 0: '未接单', 1: '已接单', 2: '进行中', 3: '已完成' }
      return map[status] || '未接单'
    },
    handleReport() {
      this.$message.info('异常上报功能开发中')
    },
    async handleGrab() {
      try {
        const res = await robOrder(this.orderId)
        if (res.code === 0) {
          this.showSuccess = true
        } else if (res.code === 2) {
          this.showSignModal = true
        } else {
          this.$message.error(res.msg || '抢单失败，请重试')
        }
      } catch (err) {
        this.$message.error(err.message || '抢单失败，请重试')
      }
    },
    async handleAgree() {
      try {
        const res = await agreePush(this.orderId)
        if (res.code === 0) {
          this.showSuccess = true
        } else if (res.code === 2) {
          this.showSignModal = true
        } else {
          this.$message.error(res.msg || '接单失败，请重试')
        }
      } catch (err) {
        this.$message.error(err.message || '接单失败，请重试')
      }
    },
    async handleSignNow() {
      this.showSignModal = false
      try {
        const res = await getSignUp()
        if (res.code === 0 && res.data && res.data.url) {
          window.location.href = res.data.url
        } else {
          this.$message.error(res.msg || '获取合同链接失败')
        }
      } catch (err) {
        this.$message.error(err.message || '获取合同链接失败')
      }
    },
    async handleStartService() {
      try {
        const res = await startServer({
          order_id: this.orderId,
          lng: getLng(),
          lat: getLat(),
          driver_city: 2
        })
        if (res.code === 0) {
          this.$router.push({
            path: '/start-service',
            query: { id: this.orderId }
          })
        } else {
          this.$message.error(res.msg || '开始服务失败')
        }
      } catch (err) {
        this.$message.error(err.message || '开始服务失败')
      }
    },
    async handleDeliver() {
      try {
        const res = await doneServer({
          order_id: this.orderId,
          lng: getLng(),
          lat: getLat(),
          driver_city: 2
        })
        if (res.code === 0) {
          this.$router.push({
            path: '/deliver-vehicle',
            query: { id: this.orderId }
          })
        } else {
          this.$message.error(res.msg || '交车失败')
        }
      } catch (err) {
        this.$message.error(err.message || '交车失败')
      }
    },
    goMyOrders() {
      this.showSuccess = false
      this.$router.push('/my-orders')
    }
  }
}
</script>

<style scoped>
.detail-page {
  min-height: 100vh;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
}

/* 顶部导航栏 */
.nav-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  background: #4a90e2;
  position: relative;
  flex-shrink: 0;
}

.nav-back {
  position: absolute;
  left: 12px;
  font-size: 22px;
  color: #fff;
  cursor: pointer;
  padding: 4px;
}

.nav-title {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}

/* 内容区 */
.content {
  flex: 1;
  padding: 12px 16px 100px;
}

/* 路线信息卡片 */
.route-card {
  position: relative;
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.route-header {
  position: relative;
  z-index: 1;
  margin-bottom: 4px;
  display: flex;
  justify-content: space-between;
}

.route-title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
}

.route-divider {
  height: 1px;
  background: #eee;
  margin: 10px 0;
}

/* 信息行 */
.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7px 0;
  position: relative;
  z-index: 1;
}

.info-label {
  font-size: 14px;
  color: #999;
  flex-shrink: 0;
}

.info-value {
  font-size: 14px;
  color: #333;
  text-align: right;
}

.info-value.bold {
  font-weight: 700;
  font-size: 15px;
}

.info-value.red {
  color: #f5222d;
}

.info-row.highlight .info-value {
  font-size: 16px;
}

/* 状态标签 */
.status-tag {
  display: inline-block;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  margin-left: 6px;
}

.tag-orange {
  background: #fff5e6;
  color: #ff9500;
}

.tag-blue {
  background: #e6f4ff;
  color: #4a90e2;
}

.tag-teal {
  background: #e6fffb;
  color: #13c2c2;
}

.tag-gray {
  background: #f5f5f5;
  color: #999;
}

/* 地址/联系人卡片 */
.location-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.location-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  border-left: 4px solid transparent;
}

.location-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  flex-shrink: 0;
}

.icon-blue {
  background: #4a90e2;
}

.icon-orange {
  background: #ff9500;
}

.location-info {
  flex: 1;
}

.contact-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
}

.contact-name {
  font-size: 15px;
  font-weight: 600;
  color: #333;
}

.contact-phone {
  font-size: 13px;
  color: #999;
}

.location-text {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.location-divider {
  height: 1px;
  background: #f0f0f0;
  margin: 14px 0;
}

/* 车辆信息卡片 */
.vehicle-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

/* 底部按钮 */
.action-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  gap: 16px;
  padding: 12px 16px 20px;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
  z-index: 100;
}

.btn {
  flex: 1;
  height: 44px;
  border: none;
  border-radius: 22px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  transition: all 0.2s;
}

.btn:active {
  transform: scale(0.97);
}

.btn-error {
  background: #f5222d;
}

.btn-primary {
  background: #4a90e2;
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
}

.btn-outline {
  background: #fff;
  color: #4a90e2;
  border: 1px solid #4a90e2;
}

/* 弹窗 */
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.success-modal {
  position: relative;
  width: 80%;
  max-width: 300px;
  background: #fff;
  border-radius: 16px;
  padding: 32px 24px 24px;
  text-align: center;
  animation: modal-in 0.3s ease;
}

@keyframes modal-in {
  from { transform: scale(0.8); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.modal-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #666;
}

.modal-close i {
  font-size: 18px;
}

.success-icon {
  width: 72px;
  height: 72px;
  margin: 0 auto 20px;
}

.success-text {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  margin-bottom: 16px;
}

.success-order {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
  background: #f5f5f5;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 20px;
}

.success-order i {
  color: #4a90e2;
  font-size: 16px;
}

.success-btn {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 22px;
  background: #4a90e2;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s;
}

.success-btn:active {
  opacity: 0.85;
}

/* 签约提示弹窗 */
.sign-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
}

.sign-modal {
  width: 80%;
  max-width: 320px;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  animation: sign-in 0.25s ease;
}

@keyframes sign-in {
  from { transform: scale(0.85); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.sign-text {
  padding: 32px 24px 24px;
  text-align: center;
  font-size: 16px;
  color: #333;
  line-height: 1.6;
}

.sign-btns {
  display: flex;
  border-top: 1px solid #eee;
}

.sign-btn {
  flex: 1;
  height: 48px;
  border: none;
  font-size: 16px;
  background: transparent;
  cursor: pointer;
}

.sign-btn.cancel-btn {
  color: #999;
  border-right: 1px solid #eee;
}

.sign-btn.cancel-btn:active {
  background: #f5f5f5;
}

.sign-btn.confirm-btn {
  color: #4a90e2;
  font-weight: 500;
}

.sign-btn.confirm-btn:active {
  background: #f0f7ff;
}

</style>
